var map = {
	"./bingbao.png": 72460,
	"./lei.png": 32819,
	"./longjuanfeng.png": 31552,
	"./qing.png": 49234,
	"./shachen.png": 8578,
	"./wu.png": 98654,
	"./xue.png": 23122,
	"./yin.png": 9905,
	"./yu.png": 92251,
	"./yujiaxue.png": 3664,
	"./yun.png": 56572
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64208;